/**
 * Branded SweetAlert2 dialogs (replaces window.confirm / alert for staff flows).
 */
import Swal from 'sweetalert2';

const brandConfirm = '#127872';
const brandCancel = '#64748b';
const brandDanger = '#b42318';

/**
 * @param {object} opts
 * @param {string} opts.title
 * @param {string} [opts.text] Plain text body (use text or html, not both).
 * @param {string} [opts.html] HTML body.
 * @param {'question'|'warning'|'info'|'success'|'error'} [opts.icon]
 * @param {string} [opts.confirmText]
 * @param {string} [opts.cancelText]
 * @param {boolean} [opts.danger] — red confirm button (destructive actions).
 * @returns {Promise<boolean>} true if user confirmed.
 */
export function luxisttConfirm({
  title,
  text,
  html,
  icon = 'question',
  confirmText = 'OK',
  cancelText = 'Cancel',
  danger = false,
}) {
  return Swal.fire({
    title,
    text,
    html,
    icon,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: danger ? brandDanger : brandConfirm,
    cancelButtonColor: brandCancel,
    reverseButtons: true,
    focusCancel: danger,
    customClass: {
      popup: 'luxistt-swal-popup',
      title: 'luxistt-swal-title',
      htmlContainer: 'luxistt-swal-body',
      confirmButton: 'luxistt-swal-btn-confirm',
      cancelButton: 'luxistt-swal-btn-cancel',
    },
  }).then((result) => result.isConfirmed === true);
}
